import React from "react";
import Main from "./pages/Main";

const App = () => {
  return (
    <div className="App">
      <Main />
    </div>
  );
};

export default App;
